/** ATO sources for the rideshare page, shared by the English and Chinese versions so the links cannot drift. */
export const RIDESHARE_CHECKED = "2026-10-28"

const SHARING =
  "https://www.ato.gov.au/businesses-and-organisations/income-deductions-and-concessions/sharing-economy-and-tax"
export const SRC = {
  registrations: {
    label: "ATO, ride-sourcing registrations",
    href: `${SHARING}/ride-sourcing/registrations`,
  },
  gst: {
    label: "ATO, ride-sourcing: reporting and paying GST",
    href: `${SHARING}/ride-sourcing/reporting-and-paying-gst`,
  },
  income: {
    label: "ATO, income and deductions for ride-sourcing",
    href: `${SHARING}/ride-sourcing/income-and-deductions-for-ride-sourcing`,
  },
  records: {
    label: "ATO, ride-sourcing record keeping",
    href: `${SHARING}/ride-sourcing/record-keeping`,
  },
  invoices: {
    label: "ATO, ride-sourcing tax invoices",
    href: `${SHARING}/ride-sourcing/tax-invoices`,
  },
  services: {
    label: "ATO, providing services through a platform",
    href: `${SHARING}/providing-services`,
  },
  activities: {
    label: "ATO, types of activities in the sharing economy",
    href: `${SHARING}/types-of-activities-in-the-sharing-economy`,
  },
  howGst: {
    label: "ATO, how GST works",
    href: "https://www.ato.gov.au/businesses-and-organisations/gst-excise-and-indirect-taxes/gst/how-gst-works",
  },
  methods: {
    label: "ATO, motor vehicle expense calculation methods",
    href: "https://www.ato.gov.au/businesses-and-organisations/income-deductions-and-concessions/income-and-deductions-for-business/deductions/deductions-for-motor-vehicle-expenses/motor-vehicle-expense-calculation-methods",
  },
}
